import { IGetJobStatusUseCase } from "../../../presentation/useCases/read/get_job_status_use_case";
import { JobStatusResponse } from "../../models/job_status_response";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetJobStatusUseCase
 */

export class GetJobStatusUseCase implements IGetJobStatusUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getJobStatus(operacaoId: string): Promise<JobStatusResponse> {
    return this.repository.getJobStatus(operacaoId);
  }
}
